import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import './UserType.css';
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { AuthContext } from '../../context/AuthContext';
import { AlunoContext } from '../../context/AlunoContext';
import { ContaPagarContext } from '../../context/ContaPagarContext';
import { ContaFinanceiraContext } from '../../context/ContaFinanceiraContext';
import { CategoriaFinanceiraContext } from '../../context/CategoriaFinanceiraContext';
import { TipoContaPagarContext } from '../../context/TipoContaPagarContext';
import { FormaPagamentoContext } from '../../context/FormaPagamentoContext';
import useVendedor from '../../context/hooks/useVendedor';
import { ContaPagarType, CreateContaPagarType, UpdateContaPagarType, EfetuarBaixaPagarRequest } from '../../context/hooks/useContaPagar';
import useUser from '../../context/hooks/useUser';
import { createPermissionChecker, PermissionModule } from '../../types/permissions';

import { CreateContaPagarModal } from '../../components/ContaPagar/CreateContaPagarModal';
import { EditContaPagarModal } from '../../components/ContaPagar/EditContaPagarModal';
import { CreateMultiplasContasPagarModal } from '../../components/ContaPagar/CreateMultiplasContasPagarModal';
import { ExportRelatorioModal } from '../../components/ContaPagar/ExportRelatorioModal';
import ModalConfirm from '../../components/ModalConfirm/ModalConfirm';

const ContaPagar = () => {
    const { objUserTk } = useContext(AuthContext);
    const { listContaPagar, contaPagarPageCount, createContaPagar, createContaPagar_semNotificacao, getAllContaPagarPaged, deleteContaPagar, efetuarBaixaContaPagar, contaPagarTotalValor, exportRelatorioContaPagar } = useContext(ContaPagarContext);
    const { handleGetContaFinanceiraByEmpresaId, listContaFinanceiraByEmpresa } = useContext(ContaFinanceiraContext);
    const { handleGetCategoriaFinanceiraByEmpresaId, listCategoriaFinanceiraByEmpresa } = useContext(CategoriaFinanceiraContext);
    const { handleGetFormaPagamentoByEmpresaId, listFormaPagamentoByEmpresa } = useContext(FormaPagamentoContext);
    const { handleGetTipoContaPagarByEmpresaId, listTipoContaPagarByEmpresa } = useContext(TipoContaPagarContext);
    const { handleGetVendedorByEmpresaId, listVendedor } = useVendedor();
    const { getAlunoPaged } = useContext(AlunoContext);
    const { getPermissionsByUser, userPermissions, useLegacyPermissions, modulePermissions } = useUser();
    const hasPermission = createPermissionChecker(useLegacyPermissions, userPermissions, modulePermissions);
    const [editingContaPagar, setEditingContaPagar] = useState<UpdateContaPagarType | null>(null);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [createMultiplasModalOpen, setCreateMultiplasModalOpen] = useState(false);
    const [exportModalOpen, setExportModalOpen] = useState(false);

    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);

    const [filters, setFilters] = useState({
        dataInicial: '',
        dataFinal: '',
        codigoTransacao: '',
        documento: '',
        historico: '',
        contaFinanceiraId: '',
        categoriaFinanceiraId: '',
        formaPagamentoId: '',
        tipoContaPagarId: '',
        terceiroId: '',
        alunoId: '',
    });
    const [selectedAlunoOption, setSelectedAlunoOption] = useState<{ value: number; label: string } | null>(null);

    useEffect(() => {
        setLoading(true);

        handleGetCategoriaFinanceiraByEmpresaId(objUserTk.EmpresaId);
        handleGetContaFinanceiraByEmpresaId(objUserTk.EmpresaId);
        handleGetFormaPagamentoByEmpresaId(objUserTk.EmpresaId);
        handleGetTipoContaPagarByEmpresaId(objUserTk.EmpresaId);
        handleGetVendedorByEmpresaId(objUserTk.EmpresaId);

        getAllContaPagarPaged(1, pageSize, objUserTk.EmpresaId, "", "", 0)
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar contas:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getAllContaPagarPaged(
            value,
            pageSize,
            objUserTk.EmpresaId,
            filters.dataInicial,
            filters.dataFinal,
            0,
            filters.codigoTransacao || undefined,
            filters.documento || undefined,
            filters.historico || undefined,
            filters.contaFinanceiraId ? Number(filters.contaFinanceiraId) : undefined,
            filters.categoriaFinanceiraId ? Number(filters.categoriaFinanceiraId) : undefined,
            filters.formaPagamentoId ? Number(filters.formaPagamentoId) : undefined,
            filters.tipoContaPagarId ? Number(filters.tipoContaPagarId) : undefined,
            filters.terceiroId ? Number(filters.terceiroId) : undefined,
            filters.alunoId ? Number(filters.alunoId) : undefined
        );
    };

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSearch = () => {
        setLoading(true);
        getAllContaPagarPaged(
            1,
            pageSize,
            objUserTk.EmpresaId,
            filters.dataInicial,
            filters.dataFinal,
            0,
            filters.codigoTransacao || undefined,
            filters.documento || undefined,
            filters.historico || undefined,
            filters.contaFinanceiraId ? Number(filters.contaFinanceiraId) : undefined,
            filters.categoriaFinanceiraId ? Number(filters.categoriaFinanceiraId) : undefined,
            filters.formaPagamentoId ? Number(filters.formaPagamentoId) : undefined,
            filters.tipoContaPagarId ? Number(filters.tipoContaPagarId) : undefined,
            filters.terceiroId ? Number(filters.terceiroId) : undefined,
            filters.alunoId ? Number(filters.alunoId) : undefined
        )
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao aplicar filtros:", error);
                setLoading(false);
            });
    };

    const handleClearFilters = () => {
        setFilters({
            dataInicial: '',
            dataFinal: '',
            codigoTransacao: '',
            documento: '',
            historico: '',
            contaFinanceiraId: '',
            categoriaFinanceiraId: '',
            formaPagamentoId: '',
            tipoContaPagarId: '',
            terceiroId: '',
            alunoId: ''
        });
        setSelectedAlunoOption(null);
        setLoading(true);
        getAllContaPagarPaged(1, pageSize, objUserTk.EmpresaId, "", "", 0)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao liimpar filtros:", error);
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleEditContaPagar = async (contaPagar: ContaPagarType) => {
        if (contaPagar.isProvisionada) {
            const createPayload: CreateContaPagarType = {
                valor: contaPagar.valor,
                taxa: contaPagar.taxa,
                vencimento: contaPagar.vencimento,
                documento: contaPagar.documento,
                codigoTransacao: contaPagar.codigoTransacao,
                historico: contaPagar.historico,
                bandeira: contaPagar.bandeira,
                empresaId: objUserTk.EmpresaId,
                contaFinanceiraId: contaPagar.contaFinanceiraId,
                categoriaFinanceiraId: contaPagar.categoriaFinanceiraId,
                formaPagamentoId: contaPagar.formaPagamentoId,
                contaProvisionadaId: contaPagar.contaProvisionadaId,
                tipoContaPagarId: contaPagar.tipoContaPagarId,
            };

            const novaConta = await createContaPagar_semNotificacao(createPayload);
            if (novaConta) {
                setEditingContaPagar(novaConta);
                setEditModalOpen(true);
            }
        } else {
            setEditingContaPagar(contaPagar);
            setEditModalOpen(true);
        }
    };

    const [confirmDeleteContaPagarId, setConfirmDeleteContaPagarId] = useState<number | null>(null);

    const handleDeleteContaPagar = (contaPagarId: number) => {
        setConfirmDeleteContaPagarId(contaPagarId);
    };

    const executeDeleteContaPagar = () => {
        if (confirmDeleteContaPagarId == null) return;
        deleteContaPagar(confirmDeleteContaPagarId)
            .then(deletedContaPagar => {
                if (!deletedContaPagar) console.error("Erro ao excluir conta.");
                getAllContaPagarPaged(1, pageSize, objUserTk.EmpresaId, "", "", 0);
            })
            .catch(error => console.error("Erro ao excluir conta:", error));
        setConfirmDeleteContaPagarId(null);
    };

    const colorMapByDay: { [key: number]: string } = {
        1: "#FFEBEE",
        2: "#E3F2FD",
        3: "#E8F5E9",
        4: "#FFF3E0",
        5: "#F3E5F5",
        6: "#FBE9E7",
        7: "#E0F2F1",
        8: "#FFF8E1",
        9: "#EDE7F6",
        10: "#ECEFF1",
        11: "#FFCDD2",
        12: "#BBDEFB",
        13: "#C8E6C9",
        14: "#FFE0B2",
        15: "#D1C4E9",
        16: "#FFCCBC",
        17: "#B2DFDB",
        18: "#FFECB3",
        19: "#D7CCC8",
        20: "#CFD8DC",
        21: "#F48FB1",
        22: "#90CAF9",
        23: "#A5D6A7",
        24: "#FFAB91",
        25: "#CE93D8",
        26: "#FF8A65",
        27: "#80CBC4",
        28: "#FFD54F",
        29: "#BCAAA4",
        30: "#B0BEC5",
        31: "#F06292"
    };

    const getColorByDay = (date: string): string => {
        const day = new Date(date).getDate();
        return colorMapByDay[day] || "#FFFFFF";
    };

    const listCategoriaFinanceiraOptions = listCategoriaFinanceiraByEmpresa.map(categoriaFinanceira => ({
        value: categoriaFinanceira.id,
        label: categoriaFinanceira.name,
    }));

    const listContaFinanceiraOptions = listContaFinanceiraByEmpresa.map(contaFinanceira => ({
        value: contaFinanceira.id,
        label: contaFinanceira.name,
    }));

    const listFormaPagamentoOptions = listFormaPagamentoByEmpresa.map(fp => ({
        value: fp.id,
        label: fp.name
    }));

    const listTipoContaPagarOptions = listTipoContaPagarByEmpresa.map(tipo => ({
        value: tipo.id,
        label: tipo.name
    }));

    const listVendedorOptions = listVendedor.map(vendedor => ({
        value: vendedor.id,
        label: vendedor.name,
    }));

    const selectStyles = {
        control: (base: any) => ({
            ...base,
            minHeight: 42,
            borderRadius: 10,
            borderColor: '#cfd6df',
            boxShadow: 'none',
            '&:hover': { borderColor: '#9aa6b2' },
        }),
    };

    const loadAlunoOptions = async (inputValue: string) => {
        if (!inputValue || inputValue.trim().length < 2) return [];
        const alunos = await getAlunoPaged(1, 0, 10, inputValue, undefined, undefined, undefined, objUserTk.EmpresaId);
        return (alunos || []).map(aluno => ({ value: aluno.id, label: aluno.name }));
    };

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Conta Pagar"}
                search={false}
                titleSearch={""}
            />

            <Container fluid className="mt-5">
                <Row className="align-items-end mb-2">
                    <Col xs="12" md="4" className="mb-2">
                        <Label className="form-control-label">Vendedor</Label>
                        <Select
                            styles={selectStyles}
                            options={listVendedorOptions}
                            value={listVendedorOptions.find(opt => opt.value.toString() === filters.terceiroId) || null}
                            onChange={(selected) =>
                                setFilters(prev => ({ ...prev, terceiroId: selected?.value.toString() || '' }))
                            }
                            isClearable
                            placeholder="Selecione o vendedor"
                        />
                    </Col>
                    <Col xs="12" md="4" className="mb-2">
                        <Label className="form-control-label">Aluno</Label>
                        <AsyncSelect
                            styles={selectStyles}
                            cacheOptions
                            defaultOptions={false}
                            loadOptions={loadAlunoOptions}
                            value={selectedAlunoOption}
                            onChange={(selected: any) => {
                                setSelectedAlunoOption(selected);
                                setFilters(prev => ({ ...prev, alunoId: selected?.value.toString() || '' }));
                            }}
                            isClearable
                            placeholder="Digite o nome do aluno..."
                            noOptionsMessage={(input) => input.inputValue.trim().length < 2 ? "Digite ao menos 2 letras" : "Nenhum aluno encontrado"}
                        />
                    </Col>
                    <Col xs="12" md="4" className="mb-2">
                        <Label className="form-control-label">Data Inicial</Label>
                        <Input
                            className="form-control-alternative"
                            type="date"
                            name="dataInicial"
                            value={filters.dataInicial}
                            onChange={handleFilterChange}
                            placeholder="Data inicial"
                            style={{ borderRadius: 10, minHeight: 42, borderColor: '#cfd6df' }}
                        />
                    </Col>
                    <Col xs="12" md="4" className="mb-2">
                        <Label className="form-control-label">Data Final</Label>
                        <Input
                            className="form-control-alternative"
                            type="date"
                            name="dataFinal"
                            value={filters.dataFinal}
                            onChange={handleFilterChange}
                            placeholder="Data final"
                            style={{ borderRadius: 10, minHeight: 42, borderColor: '#cfd6df' }}
                        />
                    </Col>
                </Row>

                <Row className="align-items-end mb-2">
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Código Transação</Label>
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="codigoTransacao"
                            value={filters.codigoTransacao}
                            onChange={handleFilterChange}
                            placeholder="Código da transação"
                            style={{ borderRadius: 10, minHeight: 42, borderColor: '#cfd6df' }}
                        />
                    </Col>
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Documento</Label>
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="documento"
                            value={filters.documento}
                            onChange={handleFilterChange}
                            placeholder="Número do documento"
                            style={{ borderRadius: 10, minHeight: 42, borderColor: '#cfd6df' }}
                        />
                    </Col>
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Histórico</Label>
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="historico"
                            value={filters.historico}
                            onChange={handleFilterChange}
                            placeholder="Buscar por histórico"
                            style={{ borderRadius: 10, minHeight: 42, borderColor: '#cfd6df' }}
                        />
                    </Col>
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Tipo de Conta Pagar</Label>
                        <Select
                            styles={selectStyles}
                            options={listTipoContaPagarOptions}
                            value={listTipoContaPagarOptions.find(opt => opt.value.toString() === filters.tipoContaPagarId) || null}
                            onChange={(selected) =>
                                setFilters(prev => ({ ...prev, tipoContaPagarId: selected?.value.toString() || '' }))
                            }
                            isClearable
                            placeholder="Selecione o tipo"
                        />
                    </Col>
                </Row>

                <Row className="align-items-end mb-2">
                    <Col xs="12" md="4" className="mb-2">
                        <Label className="form-control-label">Conta Financeira</Label>
                        <Select
                            styles={selectStyles}
                            options={listContaFinanceiraOptions}
                            value={listContaFinanceiraOptions.find(opt => opt.value.toString() === filters.contaFinanceiraId) || null}
                            onChange={(selected) =>
                                setFilters(prev => ({ ...prev, contaFinanceiraId: selected?.value.toString() || '' }))
                            }
                            isClearable
                            placeholder="Selecione uma conta financeira"
                        />
                    </Col>
                    <Col xs="12" md="4" className="mb-2">
                        <Label className="form-control-label">Categoria Financeira</Label>
                        <Select
                            styles={selectStyles}
                            options={listCategoriaFinanceiraOptions}
                            value={listCategoriaFinanceiraOptions.find(opt => opt.value.toString() === filters.categoriaFinanceiraId) || null}
                            onChange={(selected) =>
                                setFilters(prev => ({ ...prev, categoriaFinanceiraId: selected?.value.toString() || '' }))
                            }
                            isClearable
                            placeholder="Selecione uma categoria"
                        />
                    </Col>
                    <Col xs="12" md="4" className="mb-2">
                        <Label className="form-control-label">Forma de Pagamento</Label>
                        <Select
                            styles={selectStyles}
                            options={listFormaPagamentoOptions}
                            value={listFormaPagamentoOptions.find(opt => opt.value.toString() === filters.formaPagamentoId) || null}
                            onChange={(selected) =>
                                setFilters(prev => ({ ...prev, formaPagamentoId: selected?.value.toString() || '' }))
                            }
                            isClearable
                            placeholder="Selecione a forma de pagamento"
                        />
                    </Col>
                </Row>

                <Row className="align-items-center mb-4">
                    <Col xs="12" className="d-flex justify-content-start justify-content-md-end">
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#585858" }}
                            onClick={handleSearch}
                            className="mr-2"
                        >
                            Buscar
                        </Button>
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                            onClick={handleClearFilters}
                        >
                            Limpar
                        </Button>
                    </Col>
                    {hasPermission(PermissionModule.Financeiro, 1) && (
                        <Col xs="12" className="text-right mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#3D9970" }}
                                className="btn-filter ml-2"
                                onClick={() => setCreateMultiplasModalOpen(true)}
                            >
                                Adicionar múltiplas contas
                            </Button>
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                className="btn-filter"
                                onClick={() => setCreateModalOpen(true)}
                            >
                                Adicionar conta
                            </Button>
                            <Button
                                style={{ background: "#585858", color: "#FFF" }}
                                onClick={() => setExportModalOpen(true)}
                            >
                                Exportar Relatório PDF
                            </Button>
                        </Col>
                    )}
                </Row>

                {hasPermission(PermissionModule.Financeiro, 2) ? (
                    <div className="tabela-contapagar-compact">
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped custom-table">
                                <thead>
                                    <tr>
                                        <th title="Sequência">Seq.</th>
                                        <th title="Código Transação">Cód. Transação</th>
                                        <th title="Documento">Doc.</th>
                                        <th title="Observação">Obs.</th>
                                        <th title="Data de Emissão">Emissão</th>
                                        <th title="Vencimento">Vencto.</th>
                                        <th>Valor</th>
                                        <th>Taxa</th>
                                        <th>Status</th>
                                        <th title="Forma de Pagamento">Forma Pgmt.</th>
                                        <th title="Tipo de Conta">Tipo Conta</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listContaPagar.map((contaPagar: ContaPagarType, index: number) => {

                                        const rowColor = getColorByDay(contaPagar.vencimento);

                                        return (
                                            <tr key={index} style={{ backgroundColor: rowColor }}>
                                                <td>{contaPagar.id}</td>
                                                <td>{contaPagar.codigoTransacao}</td>
                                                <td>{contaPagar.documento}</td>
                                                <td>
                                                    <div className="conta-observacao-compact" title={contaPagar.historico || undefined}>
                                                        {contaPagar.historico}
                                                    </div>
                                                </td>
                                                <td>{new Date(contaPagar.dataEmissao).toLocaleDateString('pt-BR')}</td>
                                                {/* <td>{new Date(contaPagar.vencimento).toLocaleDateString('pt-BR')}</td> */}
                                                <td>{contaPagar.vencimento && contaPagar.vencimento.split('-').reverse().join('/')}</td>
                                                <td>{contaPagar.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                <td>{contaPagar.taxa.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                <td>
                                                    {contaPagar.status === 0 && <span className="badge badge-warning">Pendente</span>}
                                                    {contaPagar.status === 1 && <span className="badge badge-success">Concluído</span>}
                                                </td>
                                                <td>{contaPagar.formaPagamentoName}</td>
                                                <td>{contaPagar.tipoContaPagarName}</td>
                                                <td>
                                                    {hasPermission(PermissionModule.Financeiro, 3) && (
                                                        <Button onClick={() => { handleEditContaPagar(contaPagar) }}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                    )}
                                                    {hasPermission(PermissionModule.Financeiro, 4) && (
                                                        <Button onClick={() => handleDeleteContaPagar(contaPagar.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                                    )}
                                                    <Button
                                                        onClick={() => {
                                                            const request: EfetuarBaixaPagarRequest = {
                                                                contaPagarId: contaPagar.id,
                                                                dataBaixa: new Date().toISOString(),
                                                                valorPago: contaPagar.valor,
                                                            };
                                                            efetuarBaixaContaPagar(request)
                                                                .then(success => {
                                                                    if (success) {
                                                                        getAllContaPagarPaged(1, pageSize, objUserTk.EmpresaId, "", "", 0);
                                                                    } else {
                                                                        console.error("Erro ao efetuar baixa na conta.");
                                                                    }
                                                                })
                                                                .catch(error => console.error("Erro ao efetuar baixa:", error));
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-check"></i>
                                                    </Button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                            <div className="text-right mt-3">
                                <strong>
                                    Total das contas filtradas:&nbsp;
                                    {typeof contaPagarTotalValor === "number"
                                        ? contaPagarTotalValor.toLocaleString("pt-BR", {
                                            style: "currency",
                                            currency: "BRL",
                                        })
                                        : "R$ 0,00"}
                                </strong>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
                                <div className="mb-2 mb-md-0">
                                    <Label className="form-control-label mr-2">Registros por página:</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="select"
                                        bsSize="sm"
                                        style={{ width: "100px", display: "inline-block" }}
                                        value={pageSize}
                                        onChange={(e) => {
                                            const newSize = parseInt(e.target.value);
                                            setPageSize(newSize);
                                            getAllContaPagarPaged(
                                                1,
                                                newSize,
                                                objUserTk.EmpresaId,
                                                filters.dataInicial,
                                                filters.dataFinal,
                                                0,
                                                filters.codigoTransacao || undefined,
                                                filters.documento || undefined,
                                                filters.historico || undefined,
                                                filters.contaFinanceiraId ? Number(filters.contaFinanceiraId) : undefined,
                                                filters.categoriaFinanceiraId ? Number(filters.categoriaFinanceiraId) : undefined,
                                                filters.formaPagamentoId ? Number(filters.formaPagamentoId) : undefined,
                                                filters.tipoContaPagarId ? Number(filters.tipoContaPagarId) : undefined,
                                                filters.terceiroId ? Number(filters.terceiroId) : undefined,
                                                filters.alunoId ? Number(filters.alunoId) : undefined
                                            );
                                        }}
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={15}>15</option>
                                        <option value={20}>20</option>
                                        <option value={25}>25</option>
                                    </Input>
                                </div>

                                {contaPagarPageCount && (
                                    <div className="mt-2 mt-md-0">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={contaPagarPageCount}
                                        />
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>
                    </div>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar as contas do financeiro.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            <CreateContaPagarModal
                isOpen={createModalOpen}
                toggle={() => setCreateModalOpen(false)}
                onCreated={() => getAllContaPagarPaged(1, pageSize, objUserTk.EmpresaId, "", "", 0)}
            />

            <EditContaPagarModal
                isOpen={editModalOpen}
                toggle={() => setEditModalOpen(false)}
                conta={editingContaPagar}
                onUpdated={() => getAllContaPagarPaged(1, pageSize, objUserTk.EmpresaId, "", "", 0)}
            />

            <CreateMultiplasContasPagarModal
                isOpen={createMultiplasModalOpen}
                toggle={() => setCreateMultiplasModalOpen(false)}
                onCreated={() => {
                    setCreateMultiplasModalOpen(false);
                    getAllContaPagarPaged(1, pageSize, objUserTk.EmpresaId, "", "", 0);
                }}
            />

            <ExportRelatorioModal
                isOpen={exportModalOpen}
                toggle={() => setExportModalOpen(false)}
                filters={filters}
                onExport={(selectedFields) => exportRelatorioContaPagar(filters, selectedFields)}
            />

            <ModalConfirm
                openModal={confirmDeleteContaPagarId !== null}
                closeModal={() => setConfirmDeleteContaPagarId(null)}
                handleConfirm={executeDeleteContaPagar}
                title="Excluir conta"
                message="Tem certeza que deseja excluir esta conta? Esta ação não pode ser desfeita."
            />
        </>
    );
};

export default ContaPagar;

